module.exports = __webpack_public_path__ + "img/img-avatar04.4da743c4.jpg";